// extracted by mini-css-extract-plugin
export default {"container":"SkeletonInitPage_container__P-fk+","title":"SkeletonInitPage_title__2mBIT","listWrapper":"SkeletonInitPage_listWrapper__tOZcO"};